import {TimeScale} from '../types';

export const FMD_BREAKPOINT_POPOVER_WIDTH = 672;
export const LG_BREAKPOINT_POPOVER_WIDTH = 612;

export const DISCRET_RANGE_PICKER_HEIGHT = 290;

export const TIME_SCALES = Object.values(TimeScale).filter(
    timeScale => timeScale !== TimeScale.HOURLY
);

export enum Breakpoint {
    XS = 'xs',
    FXS = 'fxs',
    SM = 'sm',
    FSM = 'fsm',
    MD = 'md',
    FMD = 'fmd',
    LG = 'lg',
    FLG = 'flg',
    XL = 'xl'
}

const keys = Object.values(Breakpoint);

const values = {
    [Breakpoint.XS]: 0,
    [Breakpoint.FXS]: 375,
    [Breakpoint.SM]: 600,
    [Breakpoint.FSM]: 768,
    [Breakpoint.MD]: 960,
    [Breakpoint.FMD]: 1024,
    [Breakpoint.LG]: 1280,
    [Breakpoint.FLG]: 1440,
    [Breakpoint.XL]: 1920
};

export const breakpoints: {
    keys: typeof keys;
    name: typeof Breakpoint;
    values: {[key in Breakpoint]: number};
} = {
    keys,
    name: Breakpoint,
    values
};
